import React, { useState, useEffect } from 'react'
import { WarningModal } from '../components-layout';
import { CheckCircleIcon, ExclamationCircleIcon, ComputerDesktopIcon } from '@heroicons/react/24/outline';
import { Header, Layout, Container } from '../components-layout';
import Cookies from 'universal-cookie';
import { useSelector } from 'react-redux';
import { fetchApi } from '../tools';
import GridEquipos from './components/GridEquipos';

const EquiposIndex = () => {

    const cookies = new Cookies();
    const urlSchool = cookies.get('__urlSchoolApi') // url para enviar al api viene de cookies
    console.log(urlSchool)
    //const urlInvoice = cookies.get("__urlInvoiceApi"); // url para enviar al api viene de cookies
    //const urlCursos = cookies.get("__urlCursosApi"); // url para enviar al api viene de cookies
    const user = useSelector((state) =>  state['auth']['user'])
    
    //const IdSede = useSelector((state) => state.auth.IdSede);
    //const IdEmp = useSelector((state) =>  state.auth.IdEmp);
    const { headersAPI: headers } = useSelector((state) => state?.url);
    const  userObj = JSON.parse(user);

    const [modal, setModal] = useState({
        ok: false,
        show: false,
        msg: "",
    })

    const [loading, setLoading] = useState(false)
    const [equipos, setEquipos] = useState([])
    const [infoSede, setInfoSede] = useState({
        IdSede: null,
        Nombre: null,
        Sedes: []
    })

    function transformSedes(content) {
      let transformed = content
      transformed.map(e => {
            if(e.Iniciales === 'Z7'){
                e.Iniciales = 'SJ'
            }
            if(e.Iniciales === 'Z12'){
                e.Iniciales = 'PT'
            }
            if(e.Iniciales === 'EN'){
                e.Iniciales = 'NJ'
            }
            if(e.Iniciales === 'VB'){
                e.Iniciales = 'VD'
            }
            if(e.Iniciales === 'AJ'){
                e.Iniciales = 'JC'
            }
        })
        console.log(transformed)
        return transformed
    }

    const loadSedes = async () => {
        try {
          const response = await fetchApi({
            url: urlSchool + "/utils/busquedas",
            headers: headers,
            content: { opcion: "SEDES" },
          });
          setInfoSede({
            ...infoSede,
            Sedes: transformSedes(response),
        })
        } catch (error) {}
    };

    const loadEquipos = async () => {
        try {
          const response = await fetchApi({
            url: urlSchool + "/utils/busquedas",
            headers: headers,
            content: {
              "opcion": "DEVICES",
              "Idsede": infoSede.IdSede
            },
          });
          setEquipos(response)
        } catch (error) {}
    };

      useEffect(() => {
        loadEquipos()
      }, [infoSede.IdSede])
      
      useEffect(() => {
        loadSedes()
      }, [])

      const handleChangeTextbox = (e, index) => {
        let a = [...equipos]
        a[index][e.target.name] = e.target.value
        setEquipos(a)
      }

      const IsAllCorrect = () => {
        const error = equipos.some( el => el.Incorrecto)
        return !error
      }
      
      const showMessage = () => {
        window.scrollTo(0, 0)
        setModal({
          ...modal,
          ok: false,
          msg: "Verifique los datos",
          show: true,
      })        
      }

      const addSedeToEquipos = (equipos) => {
        const a = [...equipos]
        a.forEach(el => {
            el.IdSede = infoSede.IdSede
        })
        return a
      }

      const handleSave = async () => {
        setLoading(true)
        const response = await fetchApi({
            url: urlSchool + "/utils/mac_equipos",
            method: 'POST',
            headers: headers,
            content: {
                "Device": addSedeToEquipos(equipos),
            }
        })
        setLoading(false)
        if(response.msg.Error === "0"){
            setModal({
                ...modal,
                ok: true,
                msg: response.msg.Mensaje,
                show: true,
                reload: true
            })
        }else{
            setModal({
                ...modal,
                ok: false,
                msg: "Error al guardar los datos",
                show: true,
                reload: false
            })
        }
        
      }

      const handleGridInput = (e, index) => {
        if(e.target.name==="MacAddress"){
            if(!e.target.value){
                const a = [...equipos]
                a[index]['Incorrecto'] = false
                setEquipos(a)
            }else{
                const regex = /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/
                if(regex.test(e.target.value)){
                    const a = [...equipos]
                    a[index]['Incorrecto'] = false
                    setEquipos(a)
                }else{
                    const a = [...equipos]
                    a[index]['Incorrecto'] = true
                    setEquipos(a)
                }
            }
        }
      }

  return (
    <>
      <Layout userObj={userObj} activeTab="Equipos">
        <Container height="h-full">
          <Header title="Equipos" logo={ComputerDesktopIcon} />
          <WarningModal
            open={loading ? true : false}
            image={<img src="./img/loader.gif" alt="loading" />}
            opacity="bg-opacity-100"
          />
          <WarningModal
            open={modal.show ? true : false}
            image={
              modal.ok ? (
                <CheckCircleIcon className="h-20 w-20 text-green-500 mx-auto" />
              ) : (
                <ExclamationCircleIcon className="h-20 w-20 text-red-500 mx-auto" />
              )
            }
            title="Aviso"
            subtitle={<span>{modal.msg}</span>}
            opacity="bg-opacity-50"
          >
            <div className="mt-5 sm:mt-6">
              <button
                onClick={() => {
                  if (modal.reload) {
                    window.location.reload();
                  }
                  setModal((curr) => ({
                    ...curr,
                    show: false,
                    reload: false,
                  }));
                }}
                type="button"
                className="inline-flex w-full justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-150 ease focus:outline-none sm:text-sm"
              >
                Entendido
              </button>
            </div>
          </WarningModal>
          <div className={"shadow-white shadow-sm  rounded-md flex flex-col w-full xl:w-[70%] mx-auto gap-2 elementFadeIn"}>
            <div className="flex flex-col">

          <div className={"flex flex-col xl:flex-row m-4 mx-auto"}>
                {infoSede.Sedes.length > 0 && infoSede?.Sedes?.map((element, index) => (
                    <>
                  <div key={index + Math.random(1000)} className="flex flex-col ">
                  <div
                    key={index  + Math.random(1000)} 
                    className={  infoSede?.IdSede === element['IdSede'] ? 
                    "grid md:m-1 w-20 h-20 rounded-full ring-azulBrillanteMira  ring-1 bg-azulBrillanteMira hover:shadow-md hover:shadow-white transition duration-150 ease-out hover:ease-in mx-auto hover:cursor-pointer":
                    "grid md:m-1 w-20 h-20 rounded-full ring-azulBrillanteMira  ring-1 hover:bg-azulBrillanteMira hover:shadow-md hover:shadow-white transition duration-150 ease-out hover:ease-in mx-auto hover:cursor-pointer" }
                     onClick={() => setInfoSede({...infoSede, IdSede:element['IdSede'], Nombre: element.Sede})}
                     onMouseEnter={() => setInfoSede({...infoSede, Nombre: element.Sede})}
                     >
                    <p className="m-auto text-white text-2xl font-bold"
                    onClick={() => setInfoSede({...infoSede, IdSede:element['IdSede'], Nombre: element.Sede})}
                    >
                      {infoSede.Sedes[index]["Iniciales"]}
                      </p>
                  </div>
                  <p className="md:hidden /md:flex m-auto text-white"
                  onClick={() => setInfoSede({...infoSede, IdSede:element['IdSede'], Nombre: element.Sede})}
                  >
                    {element?.Sede}
                    </p>
                  </div>
                  </>
                  ))}
            </div>
            <div className={"flex /w-full flex-col"}>
                  <p className="text-secundario m-auto hidden xl:inline">{"Seleccione la sede para continuar"}</p>
                  <p className={"m-auto text-white hidden md:flex"}>{infoSede?.Nombre}</p>
              </div>
                  </div>
            {
              infoSede.IdSede?
              <>
                 <GridEquipos
                   filteredData={equipos}
                   handleGridInput={handleGridInput}
                   handleChangeTextbox={handleChangeTextbox}
                 />
                 <div className='flex flex-row justify-end'>
                    <div
                      type="button"
                      className="m-4 inline justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-100 ease focus:outline-none sm:text-sm cursor-pointer"
                      onClick={() => {
                        !IsAllCorrect()? showMessage(): handleSave()}}
                    >
                      Guardar
                 </div>
              </div>
              </>
              : null
            }
          </div>
        </Container>
      </Layout>
    </>
  )
}

export default EquiposIndex